import { Download, Link2, RefreshCw } from "lucide-react";
import React, { useState } from "react";
import AdminPageLayout from "../../components/AdminPageLayout";
import { useTheme } from "../../contexts/ThemeContext";
import FetchInfoTable from "./CitriniImport/components/FetchInfoTable";
import MappingsTable from "./CitriniImport/components/MappingsTable";

type Tab = "history" | "mappings";

const TABS: { id: Tab; label: string; icon: React.ElementType }[] = [
  { id: "history", label: "Fetch History", icon: Download },
  { id: "mappings", label: "Mappings", icon: Link2 },
];

const CitriniImportPage: React.FC = () => {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";
  const [activeTab, setActiveTab] = useState<Tab>("history");
  const [tabKey, setTabKey] = useState(0);

  return (
    <AdminPageLayout
      title="Citrini Import"
      description="View and manage Citrini fetch data and product mappings"
      actions={
        <button
          onClick={() => setTabKey((k) => k + 1)}
          className={`px-4 py-2 text-sm font-medium rounded-lg border flex items-center ${
            isDarkMode
              ? "bg-rp-surface border-rp-separator text-rp-grey/70 hover:bg-rp-surface-raised"
              : "bg-white border-gray-300 text-gray-700 hover:bg-gray-50"
          }`}
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Refresh
        </button>
      }
    >
      {/* Tabs */}
      <div
        className={`flex space-x-1 border-b mb-4 ${
          isDarkMode ? "border-rp-separator" : "border-gray-200"
        }`}
      >
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center px-4 py-2.5 text-sm font-medium border-b-2 transition-colors -mb-px ${
                isActive
                  ? isDarkMode
                    ? "border-blue-500 text-blue-400"
                    : "border-blue-600 text-blue-600"
                  : isDarkMode
                    ? "border-transparent text-rp-grey/50 hover:text-rp-grey/70 hover:border-rp-separator"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              <Icon className="w-4 h-4 mr-2" />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab content */}
      {activeTab === "history" && <FetchInfoTable key={`history-${tabKey}`} isDarkMode={isDarkMode} />}
      {activeTab === "mappings" && <MappingsTable key={`mappings-${tabKey}`} isDarkMode={isDarkMode} />}
    </AdminPageLayout>
  );
};

export default CitriniImportPage;
